import apiRequest from 'client/helpers/apiRequest';
import { OutreachEntity, OutreachEntityType, Project } from '@interfaces/outreach-entity';
import ListResponse from '@interfaces/list-response';
import { OutreachRequestParams } from '@interfaces/outreach-request-params';
import { YearsFilter } from '@interfaces/years-filter';

export type OutreachResponseList<T> = ListResponse<OutreachEntity<T>>;
export type ProjectList = OutreachResponseList<Project>;

export function fetchProjectsPage(requestParams: OutreachRequestParams = {}): Promise<ProjectList> {
    const { page: pageNumber = 1, pageSize = 5, year } = requestParams;

    const params: any = { pageNumber, pageSize };
    if (year) {
        params.year = year;
    }

    return apiRequest.get<ProjectList>(`/api/outreach/${OutreachEntityType.project}`, { params });
}

export function fetchProjectsFilters(): Promise<YearsFilter> {
    return apiRequest.get<YearsFilter>(`/api/outreach/${OutreachEntityType.project}/filters`);
}
